import {UngroupedCollapsibleCell} from './ungrouped_cell'
import {GroupedCollapsibleCell} from './grouped_cell'
import {getDefaultCollapsedCellName} from './get_cell_component'

export const CollapsibleCell = ({cell, isGroupedColumn}) => {
	const {column} = cell
	const {columnDef} = column
	const {aggregates, collapsibleCell, cell: nonCollapsibelCell} = columnDef

	// Always show a value for the grouped column, otherwise it wouldn't be clear what you grouped on.
	if (isGroupedColumn) return <GroupedCollapsibleCell cell={cell} />

	// If not grouped but aggregates still make sense.
	if (aggregates || collapsibleCell || getDefaultCollapsedCellName(nonCollapsibelCell)) return <UngroupedCollapsibleCell cell={cell} />

	// If aggregate values make no sense, simply return null.
	return null
}
